import { createAction } from 'redux-actions';

export const setSearchCriteriaAction = createAction('SEARCH/SET_SEARCH_CRITERIA');
export const setSearchRawPrefsAction = createAction('SEARCH/SET_SEARCH_CRITERIA_RAW_PREFS');
export const resetSearchCriteriaAction = createAction('SEARCH/RESET_SEARCH_CRITERIA');
